<template>
    <div class="wrap">
        <div class="head">
            <banner></banner>
        </div>
        <div class="content">
            <div class="content-wrap">
                <input type="text" v-model="token" placeholder="请输入口令" >
                <label @click="toIndex">登录</label>
            </div>
        </div>
        <div class="bottom">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bottom_1.png">
        </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {isMobile} from "@/assets/util/util";
    import {openId} from "@/assets/js/api";
    export default {
        name: "RepToken",
        data(){
            return{
                token:"",
                repToken:null,
                code:this.$route.query.code,
                repOpenid: null,
            }
        },
        components:{
            Banner
        },
        methods:{
            toIndex(){
                if(this.token==""){
                    this.$toast("请输入口令")
                    return
                }
                else if(this.token!="k速达"&&this.token!="K速达"){
                    this.$toast("口令错误")
                    return;
                }
                this.$router.push({path:"./repIndex",query:{repOpenid:this.repOpenid}})
            },
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.repOpenid= res.data.openId;
                }
            },
        },
        mounted(){
            // 获取openid
            if(this.code!=null){
                this.getOpenId(this.code)
            }else{
                if(isMobile()){//移动端重定向，把code带回来
                    let url = "http://app.iumed.com.cn/repToken"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        /*height: 300px;*/
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .bottom{
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        img{
            width: 70%;
            object-fit: contain;
        }
    }
    .content{
        /*background: red;*/
    }
    .content-wrap{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        input{
            background: #eee;
            border: none;
            outline: none;
            border-radius: 5px;
            width: 80%;
            height: 30px;
            text-indent: 10px;
        }
        label{
            background: #2c9a58;
            width: 80%;
            height: 30px;
            line-height: 30px;
            color: #FFF;
            font-size: 15px;
            border-radius: 5px;
            margin-top: 10px;
        }
    }
    input{
        border: none;
        font-size: 16px;
    }

</style>